import * as types from './types';
import firebaseService from 'Services/firebaseService';
import config from 'Config/firebase';

export function checkout(checkoutData) {
  return async dispatch => {
    dispatch({
      type: types.CHECKOUT_PROCESSING,
      payload: true,
    });

    let modData = Object.assign({}, checkoutData);

    try {
      if (checkoutData.items.length > 0) {
        const imgRes = await firebaseService.uploadImages({
          images: checkoutData.items[0].images,
          userId: checkoutData.userId,
        });

        // This is just a hack for now while we use the same image for each item
        // Later we will have to upload for each items and assign for each item
        for (let i = 0; i < modData.items.length; i++) {
          modData.items[i].images = imgRes;
        }

        const imgThumbsRes = await firebaseService.uploadImages({
          images: checkoutData.items[0].thumbs,
          userId: checkoutData.userId,
          isThumbs: true,
        });

        for (let i = 0; i < modData.items.length; i++) {
          modData.items[i].thumbs = imgThumbsRes;
        }
      }

      const checkoutRes = await fetch(`${config.functionsURL}/checkout`, {
        method: 'POST',
        // mode: 'cors', should be default cors
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(modData),
      });

      let responseJSON;
      if (checkoutRes.ok) {
        responseJSON = checkoutRes.json();
      } else {
        console.warn('Checkout Response: ', checkoutRes);
        throw new Error('Checkout error');
      }

      dispatch({
        type: types.RESET_ITEM_DRAFT,
      });
      dispatch({
        type: types.CHECKOUT_COMPLETE,
        payload: responseJSON,
      });
    } catch (error) {
      // todo should have some dispatch error here
      console.warn('Error checking out : ', error);
      alert('Checkout error' + error);
    }

    // firebaseService
    //   .uploadImages({
    //     images: checkoutData.items[0].images,
    //     userId: checkoutData.userId,
    //   })
    //   .then(imgRes => {
    //     // This is just a hack for now while we use the same image for each item
    //     // Later we will have to upload for each items and assign for each item
    //     for (let i = 0; i < modData.items.length; i++) {
    //       modData.items[i].images = imgRes;
    //     }
    //     return firebaseService.uploadImages({
    //       images: checkoutData.items[0].thumbs,
    //       userId: checkoutData.userId,
    //       isThumbs: true,
    //     });
    //   })
    //   .then(imgThumbsRes => {
    //     for (let i = 0; i < modData.items.length; i++) {
    //       modData.items[i].thumbs = imgThumbsRes;
    //     }
    //     // More on charging cards: https://github.com/stripe/react-stripe-elements/blob/master/README.md
    //     return fetch(`${config.functionsURL}/checkout`, {
    //       method: 'POST',
    //       // mode: 'cors', should be default cors
    //       headers: { 'Content-Type': 'application/json' },
    //       body: JSON.stringify(modData),
    //     });
    //   })
    //   .then(checkoutRes => {
    //     if (checkoutRes.ok) {
    //       return checkoutRes.json();
    //     } else {
    //       console.warn('Checkout Response: ', checkoutRes);
    //       throw new Error('Checkout error');
    //     }
    //   })
    //   .then(responseJSON => {
    //     dispatch({
    //       type: types.RESET_ITEM_DRAFT,
    //     });
    //     return dispatch({
    //       type: types.CHECKOUT_COMPLETE,
    //       payload: responseJSON,
    //     });
    //   })
    //   .catch(error => {
    //     // todo should have some dispatch error here
    //     console.warn('Error checking out : ', error);
    //     alert('Checkout error' + error);
    //   });
  };
}

export function checkoutReset() {
  return dispatch => {
    dispatch({
      type: types.CHECKOUT_RESET,
    });
  };
}
